import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=45fd58f8&scoped=true&"
import script from "./Tabla.vue?vue&type=script&lang=js&"
export * from "./Tabla.vue?vue&type=script&lang=js&"
import style0 from "./Tabla.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Tabla.vue?vue&type=style&index=1&id=45fd58f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd58f8",
  null
  
)

export default component.exports